import { render, staticRenderFns } from "./StockBorraMagatzemBorraList.vue?vue&type=template&id=03e8a203&scoped=true"
import script from "./StockBorraMagatzemBorraList.vue?vue&type=script&lang=js"
export * from "./StockBorraMagatzemBorraList.vue?vue&type=script&lang=js"
import style0 from "./StockBorraMagatzemBorraList.vue?vue&type=style&index=0&id=03e8a203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e8a203",
  null
  
)

export default component.exports